import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useLocalStorage } from 'utils/hooks/useLocalStorage';

import { PrimaryButton } from 'ui/button';
import { MODAL_SIZES, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { prefixWithUserProject } from 'utils/indexPageUtils';

import { TemplateEditorSelector, TemplateNameInput } from '../../components';
import { TEMPLATE_MENU_OPTIONS } from '../../constants';
import { createTemplate } from '../../ducks/actions';
import { DRAG_DROP_OPTIONS } from '../constants';

type NewInAppTemplateModalProps = {
  /* Function to Close Modal */
  closeModal: () => void;
  /* content strings to render */
  content: Record<string, unknown>;
  currentFolderId: number | null;
  /* Identifier of the template type selected */
  id: string;
};

export const NewInAppTemplateModal = ({
  closeModal = () => null,
  content,
  currentFolderId,
  ...props
}: NewInAppTemplateModalProps) => {
  const [templateName, setTemplateName] = useState('');
  const [selectedEditor, setSelectedEditor] = useLocalStorage(
    prefixWithUserProject('template-index-inapp-editor'),
    '',
  );

  const dispatch = useDispatch();

  useEffect(() => document.getElementById('in-app-template-name-input')?.focus(), []);

  const {
    templateNameInput,
    // @ts-ignore
    modalHeader: { prefix, suffix },
    templateEditorSelector,
    createTemplateButtonText,
  } = content;

  return (
    <Modal
      data-test={`in-app-template-modal`}
      isModalOpen={true}
      onClose={closeModal}
      size={MODAL_SIZES.MEDIUM}
      {...props}
    >
      <ModalHeader>{`${prefix} ${TEMPLATE_MENU_OPTIONS['in-app'].modalLabel} ${suffix}`}</ModalHeader>
      <ModalBody>
        <TemplateNameInput
          content={templateNameInput}
          templateName={templateName}
          setTemplateName={setTemplateName}
          id="in-app-template-name-input"
        />
        <TemplateEditorSelector
          content={templateEditorSelector as Record<string, any>}
          setSelectedEditor={setSelectedEditor}
          selectedEditor={selectedEditor}
          isWYSIWYGEnabled
        />
      </ModalBody>
      <ModalFooter>
        <PrimaryButton
          data-test="create-template-button"
          onClick={() =>
            dispatch(
              createTemplate({
                currentFolderId,
                name: templateName,
                messageMedium: TEMPLATE_MENU_OPTIONS['in-app'].slug,
                // @ts-ignore
                dragDropSlug:
                  // @ts-ignore
                  selectedEditor !== templateEditorSelector.wysiwyg.title &&
                  DRAG_DROP_OPTIONS.blank.id,
              }),
            )
          }
          isDisabled={
            selectedEditor.length === 0 || templateName.length === 0 || templateName.length > 255
          }
        >
          {/* @ts-ignore */}
          <span data-test="create-template-button-text">{createTemplateButtonText}</span>
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
